function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, QRCode, Tag, Radio, Alert, Table, Form } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "../../components/includes/Common";
import TicketViewCardHorizontal from "../../components/TicketViewCardHorizontal";
import TicketViewCardTwoTone from "../../components/TicketViewCardTwoTone";
import TicketViewBracelet from "../../components/TicketViewBracelet";
import TicketViewBraceletLight from "../../components/TicketViewBraceletLight";
import TicketViewCardWhiteLabel from "../../components/TicketViewCardWhiteLabel";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TicketsList = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$tickets = _ref.tickets,
    tickets = _ref$tickets === void 0 ? [] : _ref$tickets,
    _ref$design = _ref.design,
    design = _ref$design === void 0 ? 0 : _ref$design;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  useEffect(function () {}, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        ref: ref,
        id: "printable",
        children: /*#__PURE__*/_jsx(ARow, {
          gutter: [20, 20],
          children: tickets.map(function (t) {
            return /*#__PURE__*/_jsxs(ACol, {
              span: 12,
              children: [design == 0 && /*#__PURE__*/_jsx(TicketViewCardHorizontal, {
                ticket: t
              }), design == 1 && /*#__PURE__*/_jsx(TicketViewBracelet, {
                ticket: t
              }), design == 2 && /*#__PURE__*/_jsx(TicketViewCardTwoTone, {
                ticket: t
              }), design == 3 && /*#__PURE__*/_jsx(TicketViewBraceletLight, {
                ticket: t
              }), design == 4 && /*#__PURE__*/_jsx(TicketViewCardWhiteLabel, {
                ticket: t
              })]
            });
          })
        })
      })
    })
  });
});
export default TicketsList;